module.exports = __webpack_public_path__ + "img/GoTop.d32809c.svg";